import { ReactNode } from 'react';

interface MainAreaProps {
  children?: ReactNode;
}

export default function MainArea({ children }: MainAreaProps) {
  // Set z-index to 1 so that information tooltips hover over the sidebar.
  return <main className="main-area z-index-1">{children}</main>;
}
